import React from "react";
import SomeDayIconBig from "icons/SomedayIconBig";

export default function SomedayBackdrop(props) {
  return (
    <div className="someday-backdrop">
      <div className="someday-icon-big">
        <SomeDayIconBig />
      </div>
      <span className="someday-title">Someday</span>
    </div>
  );
}
